<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <!--Start Top Section-->
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12">
            <v-row>
              <v-col
                :class="!$vuetify.breakpoint.smAndUp ? 'pb-1' : ''"
                cols="12"
                md="6"
                lg="6"
                sm="6"
              >
                <v-card-title class="headline">
                  AMS Visit Date Schedule
                </v-card-title>
              </v-col>
              <v-col
                cols="12"
                md="6"
                lg="6"
                sm="6"
                :class="!$vuetify.breakpoint.smAndUp ? 'py-1' : ''"
              >
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    class="mr-2"
                    small
                    dense
                    color="accent"
                    @click="openUploadDialog"
                    v-if="isUploadAccess"
                  >
                    <v-icon left small>mdi-upload</v-icon> Upload Calender
                  </v-btn>
                  <router-link
                    slot="right"
                    :to="{
                      name: 'amsCenterAllocation',
                      params: { selectedZoneId: this.zoneID }
                    }"
                  >
                    <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      elevation="1"
                      right
                      small
                      dense
                      top
                    >
                      <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                    >
                    <v-btn
                      v-else
                      fixed
                      right
                      fab
                      small
                      color="grey lighten-2"
                      elevation="1"
                      class="mr-n2 mt-10"
                      style="opacity: 0.6"
                    >
                      <v-icon>mdi-arrow-left</v-icon></v-btn
                    >
                  </router-link>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
            <v-card-text>
              <v-expansion-panels
                flat
                focusable
                v-model="defaultPanel"
                style="border: solid 1px #e4e4e4"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="py-0"
                    @click="handleExpension"
                    disable-icon-rotate
                    style="min-height: 50px"
                    :color="isOpen ? '#5d58ef' : ''"
                    :class="isOpen ? 'white--text' : ''"
                  >
                    <span
                      ><v-icon :color="isOpen ? 'white' : ''"
                        >mdi-filter</v-icon
                      >
                      Filters</span
                    >
                    <template v-slot:actions>
                      <v-icon :color="isOpen ? 'white' : ''">{{
                        isOpen ? 'mdi-minus' : 'mdi-plus'
                      }}</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <form @submit.prevent="getAMVisitSchedule">
                      <v-row class="mt-4">
                        <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                          <label class="font-weight-medium body-2">
                            Zone <span class="red--text">*</span>
                          </label>
                          <v-autocomplete
                            placeholder="Select Zone"
                            class="my-0 py-1"
                            key="zone"
                            :items="zoneList"
                            item-text="name"
                            item-value="id"
                            v-model="zoneID"
                            @change="getZoneAMandFranchisee"
                            required
                          />
                        </v-col>
                        <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                          <label class="font-weight-medium body-2">
                            Academic Manager
                          </label>
                          <v-combobox
                            placeholder="Select Academic Manager"
                            class="my-0 py-1"
                            key="academicmanager"
                            :items="academicManagerList"
                            v-model="academicManager"
                            item-text="name"
                            item-value="id"
                          />
                        </v-col>
                        <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                          <label class="font-weight-medium body-2">
                            Priority
                          </label>
                          <v-autocomplete
                            placeholder="Select Priority"
                            class="my-0 py-1"
                            key="priority"
                            v-model="priorityID"
                            :items="priorityList"
                            item-text="annotation"
                            item-value="id"
                          />
                        </v-col>
                        <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                          <label class="font-weight-medium body-2">
                            Center
                          </label>
                          <v-combobox
                            placeholder="Select Center"
                            class="my-0 py-1"
                            key="center"
                            :items="franchiseeList"
                            item-text="companyName"
                            item-value="id"
                            v-model="selectedFranchisee"
                          />
                        </v-col>
                        <v-col
                          v-if="!$vuetify.breakpoint.xs"
                          cols="12"
                          md="12"
                          lg="12"
                          sm="12"
                          xs="12"
                        >
                          <v-card-actions class="justify-center">
                            <v-btn
                              color="#5d58ef"
                              class="white--text"
                              small
                              type="submit"
                            >
                              <v-icon left>mdi-filter</v-icon>Apply Filter
                            </v-btn>
                            <v-btn @click="resetFilter" depressed small>
                              <v-icon left> mdi-restart</v-icon> Reset Filter
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                        <v-col v-else cols="12" xs="12" class="px-0">
                          <v-row no-gutters>
                            <v-col class="mb-2" cols="12" xs="12">
                              <v-btn
                                color="#5d58ef"
                                class="white--text"
                                dense
                                style="min-width: 100%"
                                type="submit"
                              >
                                <v-icon left>mdi-filter</v-icon>Apply Filter
                              </v-btn>
                            </v-col>
                            <v-col cols="12" xs="12">
                              <v-btn
                                depressed
                                dense
                                style="min-width: 100%"
                                @click="resetFilter"
                              >
                                <v-icon left> mdi-restart</v-icon> Reset Filter
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </form>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-col>
        </v-row>
        <!--End Top Section-->
        <!--Start Bottom Section-->
        <v-row>
          <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <v-item-group
                    class="d-flex mb-2"
                    :class="
                      !$vuetify.breakpoint.smAndUp
                        ? 'justify-space-between'
                        : 'justify-left'
                    "
                  >
                    <v-item>
                      <div class="text-center mr-1">
                        <div class="text-caption font-weight-bold">H</div>
                        <v-avatar color="red darken-3" size="35">
                          <span
                            class="white--text font-weight-medium subtitle-1"
                            >{{ highPriorityFranchisee }}</span
                          >
                        </v-avatar>
                      </div>
                    </v-item>
                    <v-item>
                      <div class="text-center mr-1">
                        <div class="text-caption font-weight-bold">M</div>
                        <v-avatar color="orange darken-3" size="35">
                          <span
                            class="white--text font-weight-medium subtitle-1"
                            >{{ mediumPriorityFranchisee }}</span
                          >
                        </v-avatar>
                      </div>
                    </v-item>
                    <v-item>
                      <div class="text-center">
                        <div class="text-caption font-weight-bold">L</div>
                        <v-avatar color="green darken-3" size="35">
                          <span
                            class="white--text font-weight-medium subtitle-1"
                            >{{ lowPriorityFranchisee }}</span
                          >
                        </v-avatar>
                      </div>
                    </v-item>
                  </v-item-group>
                </v-col>
                <v-col cols="12" md="6" lg="6" xs="12" sm="6">
                  <div class="d-flex justify-end">
                    <v-btn
                      color="#5d58ef"
                      class="mt-4 mr-4 white--text"
                      dense
                      small
                      v-if="zoneID"
                      @click="amsVisitCalenderDialog = true"
                    >
                      Check AMS Availability
                    </v-btn>
                    <a
                      v-if="zoneAcademicCalendar"
                      class="mr-2 mt-4 text-decoration-underline black--text"
                      :href="zoneAcademicCalendar"
                      target="_blank"
                    >
                      View Academic Calender
                    </a>
                  </div>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="franchiseeVisit"
                :items-per-page="20"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, -1]
                }"
              >
                <template v-slot:item.franchisee.visits="{ item }">
                  <v-chip
                    class="d-flex flex-column my-1 align-start pl-4"
                    :color="getColor(item.priority)"
                    outlined
                    dense
                    small
                    v-for="(visit, index) in item.franchisee.visits"
                    :key="index + '_' + item.franchiseeName"
                  >
                    <v-icon left small> mdi-map-marker </v-icon>
                    <span>{{ visit.visitDate }}</span>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    v-if="isEditAccess"
                    class="mr-2"
                    outlined
                    small
                    dense
                    color="primary"
                    elevation="0"
                    @click="editAcademicVisitSchedule(item)"
                  >
                    <v-icon class="mr-2" left small>mdi-pencil</v-icon> Edit
                  </v-btn>
                  <v-btn outlined small dense color="success" elevation="0">
                    <v-icon class="mr-2" left small>mdi-telegram</v-icon>
                    Proceed
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-col>
        </v-row>
        <!--End Bottom Section-->
        <!--Start Upload Academic Calender-->
        <v-dialog v-model="uploadDialog" persistent max-width="600px">
          <v-card>
            <v-toolbar dark color="#5d58ef" elevation="0">
              <v-toolbar-title>Upload Academic Calender</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="uploadDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="mt-2">
              <v-container>
                <v-row>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="12" xs="12">
                    <label class="font-weight-medium body-2">
                      Zone <span class="red--text">*</span>
                    </label>
                    <v-autocomplete
                      placeholder="Select Zone"
                      class="my-0 py-1"
                      key="zone"
                      :items="zoneList"
                      item-text="name"
                      item-value="id"
                      v-model="uploadDialogZoneId"
                      :error="zoneErrorFlag"
                      :error-messages="zoneErrorMsg"
                      @change="resetError('zone')"
                    />
                  </v-col>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="12" xs="12">
                    <label class="font-weight-medium body-2">
                      Academic Year <span class="red--text">*</span>
                    </label>
                    <v-autocomplete
                      class="my-0 py-1"
                      placeholder="select Academic Year"
                      name="academicYear"
                      v-model="uploadDialogAcademicYear"
                      :items="academicYears"
                      key="id"
                      item-value="id"
                      item-text="academicYear"
                      :error="academicYearErrorFlag"
                      :error-messages="academicYearErrorMsg"
                      @change="resetError('AY')"
                    />
                  </v-col>
                  <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
                    <label class="font-weight-medium body-2">
                      Academic Calender PDF <span class="red--text">*</span>
                    </label>
                    <v-file-input
                      v-model="uploadDialogFile"
                      dense
                      placeholder="Upload Academic Calender PDF File."
                      hint="Accepted .pdf formate only."
                      accept=".pdf"
                      :error="calenderErrorFlag"
                      :error-messages="calenderErrorMsg"
                      @change="resetError('calender')"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="uploadDialog = false"> Close </v-btn>
              <v-btn color="#5d58ef" text @click="uploadAcademicYearCalender">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--End Upload Academic Calender-->
        <!--Start Academic Visit Schedule Editable Dialogue-->
        <v-dialog
          v-model="editDialog"
          persistent
          max-width="600px"
          v-if="Object.keys(editDialogData).length > 0"
        >
          <v-card>
            <v-toolbar dark color="#5d58ef" elevation="0">
              <v-toolbar-title>Reschedule Academic Visit</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="editDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="mt-2">
              <v-container>
                <v-row>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="6" xs="12">
                    <div class="d-flex justify-space-between caption">
                      <div>
                        <div class="grey--text text-subtitle-2 mb-1">Zone:</div>
                        <div
                          class="text-button mb-1"
                          v-text="editDialogData.zone"
                        ></div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="6" xs="12">
                    <div class="d-flex justify-space-between caption">
                      <div>
                        <div class="grey--text text-subtitle-2 mb-1">
                          Academic Manager:
                        </div>
                        <div
                          class="text-button mb-1"
                          v-text="editDialogData.am"
                        ></div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="6" xs="12">
                    <div class="d-flex justify-space-between caption">
                      <div>
                        <div class="grey--text text-subtitle-2 mb-1">
                          Priority:
                        </div>
                        <div
                          class="text-button mb-1"
                          v-text="editDialogData.priority"
                        ></div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6" lg="6" sm="6" xs="12">
                    <div class="d-flex justify-space-between caption">
                      <div>
                        <div class="grey--text text-subtitle-2 mb-1">
                          Franchisee:
                        </div>
                        <div
                          class="text-button mb-1"
                          v-text="editDialogData.franchisee"
                        ></div>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="12" lg="12" sm="12" xs="12">
                    <div
                      v-for="(item, index) in editDialogData.visits"
                      :key="index"
                      class="d-flex justify-space-between caption"
                    >
                      <div class="text-subtitle-2 mb-1 mt-1 pr-2">
                        Visit:{{ item.visitNo }}
                      </div>
                      <AmsDatePicker
                        @input="updateVisitDate"
                        :index="index"
                        v-model="item.visitDate"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="editDialog = false"> Close </v-btn>
              <v-btn color="#5d58ef" text @click="checkVisitScheduleDate()">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--End Academic Visit Schedule Editable Dialogue-->
        <!--Start Confirmation Dialogue for Visit Reschedule-->
        <v-dialog v-model="confirmDialog" persistent max-width="550px">
          <v-card>
            <v-toolbar dark color="#5d58ef" elevation="0">
              <v-toolbar-title
                >Are you sure to reschedule visit ?</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="confirmDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <div class="px-2 ml-auto">
                <v-alert
                  class="my-2"
                  dense
                  v-for="(item, index) in confirmDialogVisitMessage"
                  :key="index"
                  type="error"
                >
                  {{ item }}
                </v-alert>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn text @click="confirmDialog = false"> Cancel </v-btn>
              <v-btn color="#5d58ef" text @click="updateVisitSchedule">
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--End Confirmation Dialogue for Visit Reschedule-->
        <!--Start AMS Visit Calender Dialog-->
        <v-dialog
          v-model="amsVisitCalenderDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="#5d58ef" elevation="0">
              <v-toolbar-title
                >{{ zoneName }} Zone Visit Calender</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="amsVisitCalenderDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <AmsCalender
              :zoneID="zoneID"
              :amsVisitCalenderFlag="amsVisitCalenderDialog"
            />
          </v-card>
        </v-dialog>
        <!--End AMS Vist Calender Dialog-->
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Utils from '@/utils'
import constants from '@/utils/constants'
import moment from 'moment'
import _ from 'lodash'
import AmsDatePicker from '@/components/AcademicManager/datePicker'
import AmsCalender from '@/components/AcademicManager/amVisitScheduleCalender'
export default {
  name: 'amsVisitDateSchedule',
  components: {
    AmsDatePicker,
    AmsCalender
  },
  data () {
    return {
      uploadDialog: false,
      editDialog: false,
      // zoneDetails: [],
      zoneID: 0,
      zoneName: '',
      uploadDialogZoneId: 0,
      uploadDialogFile: null,
      allowedFileType: ['pdf'],
      zoneList: [],
      academicManagerList: [],
      academicManager: '',
      priorityList: [],
      priorityID: 0,
      franchiseeList: [],
      selectedFranchisee: '',
      defaultPanel: 0,
      isOpen: true,
      headers: [
        { text: 'Sr. No', align: 'start', sortable: false, value: 'srNo' },
        { text: 'Zone', value: 'zone' },
        { text: 'Academic Manager', value: 'amName' },
        { text: 'Priority', value: 'priority' },
        { text: 'Center Name', value: 'franchisee.companyName' },
        { text: 'Visits Scheduled', width: '12%', value: 'franchisee.visits' },
        { text: 'Action', width: '20%', value: 'actions' }
      ],
      franchiseeVisit: [],
      highPriorityFranchisee: 0,
      mediumPriorityFranchisee: 0,
      lowPriorityFranchisee: 0,
      editDialogData: {
        zone: '',
        am: '',
        amID: '',
        priority: '',
        franchisee: '',
        visits: []
      },
      academicYears: [],
      uploadDialogAcademicYear: '',
      zoneErrorFlag: false,
      zoneErrorMsg: '',
      academicYearErrorFlag: false,
      academicYearErrorMsg: '',
      calenderErrorFlag: false,
      calenderErrorMsg: '',
      confirmDialog: false,
      confirmDialogVisitMessage: [],
      zoneAcademicCalendar: '',
      amsVisitCalenderDialog: false
    }
  },
  watch: {
    zoneID: function (newVal) {
      this.zoneList.forEach((item) => {
        if (item.id === newVal) {
          this.zoneName = item.name
        }
      })
    }
  },
  computed: {
    isUploadAccess: function () {
      return this.checkModuleAccess('uploadCalender')
    },
    isEditAccess: function () {
      return this.checkModuleAccess('editVisitDate')
    },
    isCalenderAccess: function () {
      return this.checkModuleAccess('visitCalender')
    }
  },
  created: async function () {
    await this.getZoneData()
    await this.getPriorityData()
    await this.getAcademicYears()
  },
  methods: {
    handleExpension: function () {
      this.isOpen = !this.isOpen
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneData: async function () {
      try {
        const res = await http.get(`${constants.API_URL}/api/ams/get-zones`)
        if (res.status === 200) {
          this.zoneList = res.data.map((item) => {
            if (item.isActive) return item
          })
          this.zoneID = this.zoneList[0].id
          this.zoneName = this.zoneList[0].name
          if (this.zoneID) {
            this.getZoneAMandFranchisee()
          }
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getPriorityData: async function () {
      try {
        const res = await http.get(
          `${constants.API_URL}/api/ams/get-priority-annotation`
        )
        if (res.status === 200) {
          this.priorityList = res.data
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneAMandFranchisee: async function () {
      try {
        this.academicManager = ''
        this.priorityID = 0
        this.selectedFranchisee = ''
        this.highPriorityFranchisee = 0
        this.mediumPriorityFranchisee = 0
        this.lowPriorityFranchisee = 0
        this.franchiseeVisit = []
        this.franchiseeList = []
        this.academicManagerList = []
        await this.getAMVisitSchedule()
        const res = await http.get(
          `${constants.API_URL}/api/get/academic-manager-visit-allocation-details/${this.zoneID}`
        )
        if (res.status === 200) {
          this.franchiseeList = res.data.franchiseeList
          this.academicManagerList = res.data.academicManagers.map((item) => {
            return { id: item.amID, name: item.amName }
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getAMVisitSchedule: async function () {
      try {
        if (!this.zoneID) {
          this.errMsg('Please select zone.')
          return false
        }
        this.highPriorityFranchisee = 0
        this.mediumPriorityFranchisee = 0
        this.lowPriorityFranchisee = 0
        let payload = {}
        payload.zoneID = this.zoneID
        if (this.academicManager) {
          payload.amID = this.academicManager.id
        }
        if (this.priorityID) {
          payload.priorityID = this.priorityID
        }
        if (this.selectedFranchisee) {
          payload.franchiseeID = this.selectedFranchisee.id
        }
        let res = await http.post(
          `${constants.API_URL}/api/ams/get-am-visit-date-allocation`,
          payload
        )
        if (res.status === 200) {
          this.zoneAcademicCalendar = res.data.zoneAcademicCalendar

          this.franchiseeVisit = res.data.data
          this.franchiseeVisit.forEach((item, index) => {
            item.srNo = index + 1
            if (item.priority === 1) {
              this.highPriorityFranchisee++
              item.priority = 'High'
            } else if (item.priority === 2) {
              this.mediumPriorityFranchisee++
              item.priority = 'Medium'
            } else {
              this.lowPriorityFranchisee++
              item.priority = 'Low'
            }

            item.franchisee.visits.forEach((visitItem) => {
              if (visitItem.visitDate) {
                visitItem.visitDate = moment(
                  visitItem.visitDate,
                  'YYYY-MM-DD'
                ).format('DD/MM/YYYY')
              } else {
                visitItem.visitDate = '-'
              }
            })
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    editAcademicVisitSchedule: function (obj) {
      this.editDialog = false
      this.resetEditDialogVisit()
      if (Object.keys(obj).length > 0) {
        this.editDialog = true
        let itemObj = _.cloneDeep(obj)
        this.editDialogData = {
          zone: itemObj.zone,
          am: itemObj.amName,
          amID: itemObj.amID,
          priority: itemObj.priority,
          franchisee: itemObj.franchisee.companyName,
          franchiseeID: itemObj.franchisee.id
        }
        itemObj.franchisee.visits.forEach((item) => {
          if (item.visitDate === '-') {
            item.visitDate = null
          } else {
            item.visitDate = moment(item.visitDate, 'DD/MM/YYYY').format(
              'DD-MM-YYYY'
            )
          }
        })
        this.editDialogData.visits = itemObj.franchisee.visits
      }
    },
    updateVisitDate: function (data) {
      this.editDialogData.visits[data.index].visitDate = data.date
    },
    checkVisitScheduleDate: async function () {
      try {
        let visitDateArray = []
        this.editDialogData.visits.forEach((item) => {
          visitDateArray.push(item.visitDate)
        })
        let isDuplicate = this.hasDuplicates(visitDateArray)
        if (isDuplicate) {
          this.errMsg('Not allowed multiple visit on same date.')
          return false
        }
        this.confirmDialog = false
        this.confirmDialogVisitMessage = []
        let payload = {}
        payload.amID = this.editDialogData.amID
        payload.visits = this.editDialogData.visits.map((item) => {
          return {
            visitNo: item.visitNo,
            visitDate: item.visitDate
              ? moment(item.visitDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
            franchiseeID: this.editDialogData.franchiseeID
          }
        })
        const res = await http.post(
          `${constants.API_URL}/api/ams/check-am-visit-date`,
          payload
        )
        if (res.data.status === 200) {
          this.updateVisitSchedule()
        } else if (res.data.status === 99) {
          this.confirmDialog = true
          this.confirmDialogVisitMessage = res.data.existedVisits
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    hasDuplicates: function (arr) {
      return arr.length !== new Set(arr).size
    },
    updateVisitSchedule: async function () {
      try {
        let payload = {}
        payload.visits = this.editDialogData.visits.map((item) => {
          if (item.visitDate) {
            item.visitDate = moment(item.visitDate, 'DD-MM-YYYY').format(
              'YYYY-MM-DD'
            )
          } else {
            item.visitDate = null
          }
          return item
        })
        const res = await http.post(
          `${constants.API_URL}/api/ams/update-am-visit-date`,
          payload
        )
        if (res.status === 200) {
          this.okMsg(res.data)
          this.editDialog = false
          this.confirmDialog = false
          this.confirmDialogVisitMessage = []
          this.getAMVisitSchedule()
        } else {
          this.errMsg('Failed to Reschedule the Academic Manager visit.')
          this.editDialog = false
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    uploadAcademicYearCalender: async function () {
      if (!this.uploadDialogZoneId) {
        this.zoneErrorFlag = true
        this.zoneErrorMsg = 'Please select Zone.'
        return false
      }
      if (!this.uploadDialogAcademicYear) {
        this.academicYearErrorFlag = true
        this.academicYearErrorMsg = 'Please select Academic Year.'
        return false
      }
      if (!this.uploadDialogFile) {
        this.calenderErrorFlag = true
        this.calenderErrorMsg =
          'Please upload academic calender in (.pdf) formate.'
      }
      if (this.calenderErrorFlag) {
        return false
      }
      let formData = new FormData()
      formData.append('file', this.uploadDialogFile)
      formData.append('zoneID', this.uploadDialogZoneId)
      formData.append('academicYearID', this.uploadDialogAcademicYear)
      try {
        let res = await http.post(
          `${constants.API_URL}/api/ams/upload-zone-academic-calendar`,
          formData
        )
        if (res.status === 200) {
          this.uploadDialog = false
          this.okMsg(res.data)
        } else {
          this.errMsg('Failed to upload academic calender.')
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    resetError: function (type) {
      if (type === 'zone') {
        this.zoneErrorFlag = false
        this.zoneErrorMsg = ''
      }
      if (type === 'AY') {
        this.academicYearErrorFlag = false
        this.academicYearErrorMsg = ''
      }
      if (type === 'calender') {
        if (this.uploadDialogFile) {
          if (
            this.allowedFileType.includes(
              this.uploadDialogFile.name.split('.').pop()
            )
          ) {
            this.calenderErrorFlag = false
            this.calenderErrorMsg = ''
          } else {
            this.calenderErrorFlag = true
            this.calenderErrorMsg = 'Please select the allowed formate'
          }
        } else {
          this.calenderErrorFlag = true
          this.calenderErrorMsg =
            'Please upload academic calender in (.pdf) formate.'
        }
      }
    },
    openUploadDialog: function () {
      this.uploadDialog = true
      this.uploadDialogZoneId = ''
      this.uploadDialogAcademicYear = ''
      this.uploadDialogFile = null
      this.zoneErrorFlag = false
      this.zoneErrorMsg = ''
      this.academicYearErrorFlag = false
      this.academicYearErrorMsg = ''
      this.calenderErrorFlag = false
      this.calenderErrorMsg = ''
    },
    resetEditDialogVisit: function () {
      let obj = {
        zone: '',
        am: '',
        amID: '',
        priority: '',
        franchisee: '',
        visits: []
      }
      this.editDialogData = obj
      return true
    },
    resetFilter: function () {
      this.zoneID = ''
      this.academicManager = ''
      this.priorityID = 0
      this.selectedFranchisee = ''
      this.highPriorityFranchisee = 0
      this.mediumPriorityFranchisee = 0
      this.lowPriorityFranchisee = 0
      this.franchiseeVisit = []
      this.franchiseeList = []
      this.academicManagerList = []
    },
    getColor: function (priority) {
      if (priority === 1 || priority === 'High') {
        return 'red lighten-2'
      } else if (priority === 2 || priority === 'Medium') {
        return 'orange darken-2'
      } else {
        return 'green darken-2'
      }
    },
    errMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'error',
        timeout: 4000
      })
    },
    okMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'success',
        timeout: 4000
      })
    }
  }
}
</script>
